import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { InventoryCountForm } from "@/components/inventory-counts/inventory-count-form";
import { Id } from "@/convex/_generated/dataModel";

export const Route = createFileRoute(
  "/_authenticated/inventory-counts/$id/edit",
)({
  component: EditInventoryCountPage,
});

function EditInventoryCountPage() {
  const { id } = Route.useParams();
  return (
    <RouteGuardPermissions
      permissions={[{ module: "inventory_counts", actions: ["read", "update"] }]}
    >
      <InventoryCountForm countId={id as Id<"inventory_counts">} />
    </RouteGuardPermissions>
  );
}
